import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

export const CENTER_ADS: EffectFunction = ({ adserverContainer }: Adslot) => {
    adserverContainer.classList.add('sdgCentered');
    return () => {
        adserverContainer?.classList.remove('sdgCentered');
    };
};
